export enum DirectionEnum {

    Backward = 0,
    Forward = 1,
}